import './ChartLegend.scss';

export function ChartLegend({ datasets }: { datasets: { label: string; colour: string }[] }) {
    return (
        <div className="ChartLegend" data-testid="ChartLegend">
            {datasets.map((dataset) => {
                return (
                    <div className="ChartLegend__Label" key={dataset.label}>
                        <div
                            className="ChartLegend__Label--key"
                            style={{
                                backgroundColor: dataset.colour,
                                borderColor: dataset.colour,
                            }}
                        ></div>
                        <div className="ChartLegend__Label--text">{dataset.label}</div>
                    </div>
                );
            })}
        </div>
    );
}
